import './Wrapper.scss';

const Wrapper = ({ children }) => {
  return <div className="Wrapper">{children}</div>;
};

export default Wrapper;
